<template>
    <b-row class="mb-2">
        <b-col cols="12" :class="`text-${position}`">
            <b-button
                v-b-tooltip.hover.left="'Restaurar zoom'"
                size="sm"
                @click="onClick('reset-zoom')"
                ><i class="fas fa-fw fa-search-minus"
            /></b-button>
            <b-dropdown size="sm" no-caret class="ml-2">
                <template #button-content>
                    <i class="fas fa-fw fa-bars" />
                </template>
                <b-dropdown-item-button @click="onClick('download-csv')"
                    >Baixar CSV</b-dropdown-item-button
                >
                <b-dropdown-item-button @click="onClick('download-png')"
                    >Baixar imagem</b-dropdown-item-button
                >
            </b-dropdown>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: "ChartToolbar",
    props: {
        chart: {
            type: Object,
            default: null
        },
        position: {
            type: String,
            default: "right"
        }
    },
    methods: {
        _getYAxisLabel(dataset) {
            const { scales } = this.chart;
            if (
                typeof dataset.yAxisID !== "undefined" &&
                typeof scales[dataset.yAxisID] !== "undefined"
            ) {
                return scales[dataset.yAxisID].options.scaleLabel.labelString;
            }
            return scales["y-axis-0"].options.scaleLabel.labelString;
        },
        onClick(type) {
            if (!this.chart) {
                throw new Error("Check if chart is not undefined.");
            }
            switch (type) {
                case "reset-zoom":
                    this.chart.resetZoom();
                    break;
                case "download-csv":
                    this.downloadCSV();
                    break;
                case "download-png":
                    this.downloadPNG();
                    break;
                default:
                    throw new Error("Invalid toolbar option.");
            }
        },
        downloadCSV() {
            // nota: essa função considera que todas as séries
            // compartilham os MESMOS valores de x (tempo)
            const numDatasets = this.chart.data.datasets.length;

            if (numDatasets > 0) {
                let numPoints = 0;
                const header = ["Data e hora"];

                for (let i = 0; i < numDatasets; i++) {
                    const dataset = this.chart.data.datasets[i];

                    header.push(
                        `${dataset.label} - ${this._getYAxisLabel(dataset)}`
                    );
                    if (dataset.data.length > numPoints) {
                        numPoints = dataset.data.length;
                    }
                }

                const rows = new Array(numPoints);

                for (let i = 0; i < numPoints; i++) {
                    const cols = new Array(numDatasets + 1);

                    for (let j = 1; j <= numDatasets; j++) {
                        const dataset = this.chart.data.datasets[j - 1];
                        if (typeof dataset.data[i] !== "undefined") {
                            cols[0] = dataset.data[i].x;
                            cols[j] = dataset.data[i].y;
                        }
                    }
                    rows[i] = cols.join(",");
                }

                const csvContent = `data:text/csv;charset=utf-8,${header.join(
                    ","
                )}\n${rows.join("\n")}`;

                const link = document.createElement("a");
                link.setAttribute("href", encodeURI(csvContent));
                link.setAttribute("download", "grafico.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        downloadPNG() {
            if (this.chart.data.datasets.length > 0) {
                const dataURL = this.chart.toBase64Image();

                if (dataURL) {
                    const link = document.createElement("a");
                    link.setAttribute("href", dataURL);
                    link.setAttribute("download", "grafico.png");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        }
    }
};
</script>
